import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { StatisticsContainer } from 'src/features/statistics/containers/statistics';
import { fallback } from '@tanstack/zod-adapter';
import { z } from 'zod';

export const statisticsSearchSchema = z.object({
  filter: fallback(
    z.record(
      z.string(),
      z.object({
        value: z.union([
          z.string(),
          z.array(z.string()),
          z.array(z.array(z.string())),
          z.number(),
          z.boolean(),
          z.array(z.number()),
          z.array(z.boolean()),
        ]),
        operator: z
          .union([z.literal('custom'), z.literal('timerange')])
          .optional(),
      }),
    ),
    {},
  ).default({}),
  sort: fallback(z.array(z.string()), []).default([]),
});

export const Route = createFileRoute('/_layout/tenant/statistics/_layout/')({
  component: StatisticsContainer,
  validateSearch: zodValidator(statisticsSearchSchema),
});
